var _defs, _rect, _circle, _rect2, _path, _path2, _path3, _path4, _path5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryboardStudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6f4ee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f57fb1"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 34,
    fill: "url(#g)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 690,
    cy: 70,
    r: 90,
    fill: "#ffd75e",
    opacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 95,
    width: 292,
    height: 230,
    rx: 20,
    fill: "#fffdf7",
    stroke: "#2b1758",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 145h236M102 212h236M102 279h236M180 112v196M260 112v196",
    stroke: "#d8cee9",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 185q32-55 60 0m100-14 22-24 25 26M197 247q28-35 51 2",
    fill: "none",
    stroke: "#7053e8",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425 104h276v218H425z",
    fill: "#21153f",
    stroke: "#fff",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m523 169 92 45-92 46z",
    fill: "#ffd75e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m365 210 54 0",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 400,
    textAnchor: "middle",
    fontFamily: "Arial Black,Arial",
    fontSize: 53,
    fill: "#fff"
  }, "STORYBOARD STUDIO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryboardStudio);
export default __webpack_public_path__ + "static/media/storyboard_studio.4ffb7d7c30917c95cada527c905fe71f.svg";
export { ForwardRef as ReactComponent };